import { DownloadService } from './download.service';
import { DownloadApiService } from './download.api.service';

export * from './download.service.types';

export const downloadServices = [DownloadApiService, DownloadService];
